import type { ComponentProps } from 'react'
import { Badge } from '@/components/ui/badge'
import { SurveyStatus } from './types'

/** Translation keys — call t() in components, not at module load */
export const SURVEY_STATUS_LABEL_KEYS: Record<SurveyStatus, string> = {
    new: 'surveys.status.new',
    surveying: 'surveys.status.surveying',
    done: 'surveys.status.done',
    cancelled: 'surveys.status.cancelled',
}

export const SURVEY_STATUS_BADGE_VARIANTS: Record<
    SurveyStatus,
    ComponentProps<typeof Badge>['variant']
> = {
    new: 'info',
    surveying: 'warning',
    done: 'success',
    cancelled: 'destructive',
}

export type SurveyStatusFilter = 'all' | SurveyStatus

export const SURVEY_STATUS_FILTER_VALUES: SurveyStatusFilter[] = [
    'all',
    'new',
    'surveying',
    'done',
    'cancelled',
]

export const SURVEY_CATEGORY_LABELS: Record<string, string> = {
    service_quality: 'surveys.column.score_service_quality',
    customer_care: 'surveys.column.score_customer_care',
    tech_support: 'surveys.column.score_tech_support',
    issue_resolution: 'surveys.column.score_issue_resolution',
    referral_willingness: 'surveys.column.score_referral_willingness',
}

export const SURVEY_SCORE_MIN = 1
export const SURVEY_SCORE_MAX = 10

// Upsale potential products
export type UpsalePotentialValue = 'CLOUD' | 'CDN' | 'VNIS'

export const UPSALE_POTENTIAL_OPTIONS: {
    label: string
    value: UpsalePotentialValue
}[] = [
    { label: 'Cloud', value: 'CLOUD' },
    { label: 'CDN', value: 'CDN' },
    { label: 'VNIS', value: 'VNIS' },
]

/** Maps upsale potential values to SERVICE_COLORS keys */
export const UPSALE_SERVICE_MAP: Record<UpsalePotentialValue, string> = {
    CLOUD: 'cloud',
    CDN: 'cdn',
    VNIS: 'vnis',
}
